import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    background-color: ${COLORS.$gray10Black};
    border-radius: 8px;
    margin-bottom: 24px;
    padding: 24px;
`;
